// src/utils/resend.js

/**
 * Sends an email using Resend API via the backend endpoint
 * @param {Object} formData - The form data containing name, email, and message
 * @param {string} formData.name - The sender's name
 * @param {string} formData.email - The sender's email address
 * @param {string} formData.message - The message content
 * @returns {Promise<Object>} The response from the Resend API
 */
export const sendResendEmail = async ({ name, email, message }) => {
  try {
    const response = await fetch('/api/resend/emails', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        email,
        message,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to send email');
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};

